import { createSelector } from 'reselect'
import { localize } from 'helpers/translator'

const isAdminSelector = state => state.libraries.isAdmin

const getSchoolOverlayData = createSelector(
	[isAdminSelector],
	isAdmin => ({
		icon: isAdmin ? localize('school_library_onboarding_overlay_admin_video') : localize('school_library_onboarding_overlay_video'),
	})
)

export default getSchoolOverlayData
